<template>
  <div class="assistant-card assistant-card--mail">
    <p class="assistant-card__eyebrow">{{ t('assistant.mail.title', { store }) }}</p>

    <template v-if="state?.status === 'sent'">
      <p class="assistant-card__title assistant-card__sent">
        <svg class="assistant-icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M20 6 9 17l-5-5" /></svg>
        {{ t('assistant.mail.sent', { store }) }}
      </p>
      <p class="assistant-card__muted">{{ t('assistant.mail.sentHint', { email: replyTo }) }}</p>
    </template>

    <form v-else class="assistant-mail" @submit.prevent="submit">
      <label :for="`mail-body-${id}`">{{ t('assistant.mail.message') }}</label>
      <textarea :id="`mail-body-${id}`" v-model="body" class="assistant-field" rows="4" maxlength="2000" />
      <label :for="`mail-reply-${id}`">{{ t('assistant.mail.yourEmail') }}</label>
      <input
        :id="`mail-reply-${id}`"
        v-model="replyTo"
        class="assistant-field"
        type="email"
        inputmode="email"
        autocomplete="email"
        placeholder="namn@exempel.se"
      />
      <p class="assistant-card__muted">{{ t('assistant.mail.consent', { store }) }}</p>
      <p v-if="state?.status === 'failed'" class="assistant-card__error" role="alert">{{ state.message }}</p>
      <button type="submit" class="assistant-card__button" :disabled="!valid || state?.status === 'sending'">
        {{ state?.status === 'sending' ? t('assistant.mail.sending') : t('assistant.mail.send') }}
      </button>
    </form>
  </div>
</template>

<script setup lang="ts">
import type { AssistantCard } from '@/services/AssistantClient'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

export interface DraftState {
  status: 'sending' | 'sent' | 'failed'
  message?: string
}

const EMAIL = /^[^@\s<>,;]{1,64}@[^@\s<>,;]+\.[A-Za-z]{2,24}$/

const props = defineProps<{ card: AssistantCard; state?: DraftState }>()
const emit = defineEmits<{ send: [draft: string, body: string, replyTo: string] }>()
const { t } = useI18n()

const id = String(props.card.utkast || '')
const store = String(props.card.butik || '')
const body = ref(String(props.card.meddelande || ''))
const replyTo = ref('')
const valid = computed(() => !!body.value.trim() && EMAIL.test(replyTo.value.trim()))

const submit = () => {
  if (valid.value) emit('send', id, body.value.trim(), replyTo.value.trim())
}
</script>
